import {
  IListResponse,
  IPlatformInfoData,
} from '@/entities'
import {
  IPlatformService
} from './index'
import {
  AxiosInstance,
  AxiosResponse
} from 'axios'
import {
  defaultConfig
} from '../config'


export class PlatformService implements IPlatformService {
  constructor(private readonly axios: AxiosInstance) {}

  async getPlatformInfo(language?: string): Promise<AxiosResponse<IListResponse<IPlatformInfoData[]>>> {
    return this.axios.get('/platform_info/', defaultConfig(language))
  }

}
